<template>
  <b-modal
    id="modal-view-report-pto"
    :title="$t('watch')"
    size="xl"
    cancel-variant="outline-secondary"
    :ok-title="$t('cancel')"
    :ok-variant="'danger'"
    :cancel-title="$t('cancel')"
    ok-only
    centered
    no-close-on-backdrop
    @ok="onSubmitCategory"
  >


    <div>
      <b-table
        id="user-table"
        class="px-1 rounded mt-1"
        :items="GET_REPORT_ONE.pto"
        :fields="fields"
        show-empty
        :tbody-tr-class="['tableRowClass']"
        small
        responsive
        :empty-text="$t('empty_text')"
      >
        <template #head()="props">
          <span>{{ $t(props.label) }}</span>
        </template>


        <template #cell(master)="props">
          <div>
            <b-avatar
              v-if="
                props.item.master &&
                props.item.master.first_name &&
                props.item.master.last_name
              "
              v-b-tooltip.hover
              class="pull-up"
              :title="`${props.item.master.first_name} ${props.item.master.last_name}`"
            />

            <b-avatar v-else class="pull-up" />
          </div>
        </template>

        <template #cell(actions)="props">
          <div class="d-flex align-items-center justify-content-center">
            <b-button
              class="mr-1"
              size="sm"
              variant="danger"
              @click="onClickDelete(props.item.id)"
            >
              <feather-icon icon="TrashIcon" size="15" />
            </b-button>
          </div>
        </template>
      </b-table>
    </div>


    
  </b-modal>
</template>

<script>
import {
  BModal,
  VBModal,
  BForm,
  BButton,
  BFormInput,
  BFormGroup,
  BTabs,
  BTab,
  BTable,
  BFormDatepicker,
  BFormFile,
  BAvatar,
  BFormTextarea,
  VBTooltip,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import areYouSure from "@/mixins/areYouSure";
import { required } from "@validations";
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    BModal,
    BForm,
    BFormInput,
    BFormGroup,
    BTabs,
    BTable,
    BTab,
    BButton,
    BFormFile,
    BAvatar,
    BFormDatepicker,
    BFormTextarea,
    ValidationProvider,
    ValidationObserver,
  },

  data() {
    return {
      required,
      title: null,
      fields: [
        {
          label: "№",
          key: "id",
          thClass: "tableHeadClass",
        },
        {
          label: "courses.type",
          key: "good.product.title",
          thClass: "tableHeadClass",
        },
        {
          label: "product",
          key: "material.goods.value",
          thClass: "tableHeadClass",
        },
        {
          label: "object",
          key: "rc_object",
          thClass: "tableHeadClass",
        },
        {
          label: "unit_of_measurement",
          key: "material.goods.min_unity",
          thClass: "tableHeadClass",
        },
        {
          label: "amount",
          key: "quantity",
          thClass: "tableHeadClass",
        },
        {
          label: "date",
          key: "created_at",
          formatter: (data) => this.$dayjs(data).format("DD.MM.YYYY"),
          thClass: "tableHeadClass",
        },
        {
          label: "master",
          key: "author",
          thClass: "tableHeadClass",
        },
        {
          label: "сontract_number",
          key: "contract_number",
          thClass: "tableHeadClass",
        },
        {
          label: "actions",
          key: "actions",
          thClass: "tableHeadClass",
        },
      ],
    };
  },
  mixins: [areYouSure],
  computed: {
    ...mapGetters("contacts", ["GET_REPORT_ONE"]),
  },
  methods: {
    ...mapActions("contacts", [
      "CREATE_REPORT",
      "DELETE_CONTACT_REPORT_PTO",
      "FETCH_ONE_REPORT",
    ]),

    onClickDelete(id) {
      this.$_showAreYouSureModal().then((val) => {
        if (val) {
          this.DELETE_CONTACT_REPORT_PTO({
            id: this.GET_REPORT_ONE.id,
            data: {
              pto: id,
            },
          })
            .then(() => {
              this.FETCH_ONE_REPORT(this.GET_REPORT_ONE.id);
              // window.location.reload()
              this.$_okToast();
            })
            .catch((err) => {
              this.$_errToast(err);
            });
        }
      });
    },

    onSubmitCategory(bvModalEvt) {
      bvModalEvt.preventDefault();

      this.$nextTick(() => {
        this.$bvModal.hide("modal-view-report-pto");
      });
    },
  },
  directives: {
    "b-tooltip": VBTooltip,
  },
};
</script>

<style lang="scss">
#user-table {
  border-collapse: separate;
  border-spacing: 0 1rem;
}

#user-table .tableRowClass {
  background: white;
  transform: translateY(5px);
  transition: all 0.5s ease-in-out;
  text-align: center;
  box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);

  td {
    border-top: 0;
    padding: 20px !important;

    &:first-child {
      border-top-left-radius: 0.5rem;
      border-bottom-left-radius: 0.5rem;
    }

    &:last-child {
      border-top-right-radius: 0.5rem;
      border-bottom-right-radius: 0.5rem;
    }
  }
}

#user-table .tableRowClass:hover {
  transform: translateY(0);
}

#user-table .tableHeadClass {
  background: none !important;
  border: none !important;
}

#user-table .tableRowClass:hover {
  .tableTitle {
    color: #7367f0 !important;
  }
}

.tableHeadClass {
  text-align: center;
  padding-left: 0 !important;
}
</style>
